import {AxiosResponse} from 'axios';
import {AnyAction} from 'redux';
import {formValueSelector, SubmissionError} from 'redux-form';
import {ThunkAction} from 'redux-thunk';

import {commentFetching, commentPosted} from '../../../actions/comments';
import request, {HttpMethod} from '../../../application/api/request';
import selectAlpenroseHost from '../../../entities/pageSetup/apiHosts/selectors/selectAlpenroseHost';
import {translate} from '../../../services';
import {State} from '../../../store/initialState';

import {fetchCommentsResponse} from './fetchComments';


export default function fetchPostedComments(parentId: number | undefined): ThunkAction<Promise<void | fetchCommentsResponse>, State, unknown, AnyAction> {
  return (dispatch, getState) => {
    const state = getState();
    const designId = state.design.id;
    const formName = parentId ? `comment-${parentId}-replies` : 'comments';
    const selector = formValueSelector(formName);
    const postedComment = selector(state, 'comment');

    dispatch(commentFetching());

    return request<fetchCommentsResponse>(state, {
      url: `${selectAlpenroseHost(state)}/comments/design/${designId}`,
      method: HttpMethod.post,
      data: {
        comment: postedComment,
        parent_id: parentId
      }
    })
      .then((response: AxiosResponse<fetchCommentsResponse>) => {
        dispatch(commentPosted(response.data));

        return response.data;
      })
      .catch(() => Promise.reject(new SubmissionError({
        comment: translate('errors.inline.comment')
      })));
  };
}
